import { ProfileSliceType } from "@/types";
import { createSlice } from "@reduxjs/toolkit";
import { getProfile } from "./thunk";

const initialState: ProfileSliceType = {
  userInfo: null,
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getProfile.fulfilled, (state, { payload }) => {
      state.userInfo = payload;
    });
  },
});

export const profileReducer = profileSlice.reducer;
